<div id="loginPage" class="login-page">
  <section class="login-brand" aria-hidden="false">
    <div class="login-brand__glow"></div>
    <div class="login-brand__copy">
      <a routerLink="/Webinar-rooms" class="login-brand__logo" aria-label="LootLucky Home">
        <img src="assets/Images/logo_image.png" alt="" class="login-brand__mark" />
        <img src="assets/Images/logo_text.png" alt="LootLucky" class="login-brand__wordmark" />
      </a>
      <h1 class="login-brand__headline">Win it live.</h1>
      <p class="login-brand__lede">Join a webinar. Take a seat. Walk away with the prize.</p>
    </div>
    <div class="winner-feed" *ngIf="feedItems.length">
      <div class="winner-feed__head">
        <span class="winner-feed__live" aria-hidden="true"></span>
        <span>Live winners</span>
      </div>
      <div class="winner-feed__stream" aria-live="polite">
        <article class="winner-chip" *ngFor="let winner of feedItems; trackBy: trackFeedItem">
          <div class="winner-chip__media">
            <img *ngIf="winner.imageUrl" [src]="winner.imageUrl" [alt]="winner.prizeName" (error)="onPrizeImageError($event)" />
            <span *ngIf="!winner.imageUrl">{{ winner.initial || 'W' }}</span>
          </div>
          <div class="winner-chip__body">
            <p class="winner-chip__name">{{ winner.displayName }}</p>
            <p class="winner-chip__prize">won {{ winner.prizeName }}</p>
          </div>
          <span class="winner-chip__when">{{ formatWonOn(winner.wonOn) }}</span>
        </article>
      </div>
    </div>
  </section>

  <section class="login-panel">
    <div class="login-stack">
    <form *ngIf="loginForm" [formGroup]="loginForm" class="login-card" (ngSubmit)="onFormSubmit()">

      <div *ngIf="emailOtpRequestId === 0 && !isForgotPasswordPcessStarted && mobileOtpRequestId === 0">
        <h2 class="login-card__title">Welcome back</h2>
        <p class="login-card__subtitle">Sign in to claim seats and track your winnings.</p>

        <mat-form-field class="login-field" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="EmailId" placeholder="you@example.com" required />
          <mat-error *ngIf="loginForm.controls.EmailId.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="loginForm.controls.EmailId.hasError('email')">Please provide a valid email</mat-error>
        </mat-form-field>

        <mat-form-field class="login-field" appearance="outline">
          <mat-label>Password</mat-label>
          <input [type]="hidePw ? 'password' : 'text'" matInput formControlName="Password" placeholder="Password" required />
          <mat-icon matSuffix (click)="hidePw = !hidePw" class="login-field__toggle">
            {{ hidePw ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error *ngIf="loginForm.controls['Password'].errors?.required">Password is required</mat-error>
        </mat-form-field>

        <div class="login-actions">
          <button type="submit" class="login-submit">Sign in</button>
          <a class="login-link" role="button" tabindex="0" (click)="onForgotPassword()" (keyup.enter)="onForgotPassword()">Forgot password?</a>
        </div>

        <p class="login-card__footer">
          New here?
          <a routerLink="/Register">Create an account</a>
        </p>
      </div>

      <div *ngIf="loginForm.controls.EmailId.valid && isForgotPasswordPcessStarted">
        <h2 class="login-card__title">Reset password</h2>
        <p class="login-card__subtitle">We will send a one-time code so you can choose a new password.</p>

        <div *ngIf="userComDetails !== undefined" class="login-field">
          <h3 class="otp-header">Choose where to send the code</h3>
          <mat-radio-group [formControl]="otpTypeEmailMobile" class="otp-radio-group" (change)="onOtpTypeChange($event)">
            <mat-radio-button value="email">
              Email
              <span class="otp-destination">{{ userComDetails.emailId }}</span>
              <mat-icon class="otp-done" *ngIf="emailOtpRequestId > 0">done</mat-icon>
            </mat-radio-button>
            <mat-radio-button *ngIf="userComDetails.mobileNumber !== '0' && userComDetails.mobileNumber !== '1'" value="mobile">
              Mobile
              <span class="otp-destination">{{ userComDetails.mobileNumber }}</span>
              <mat-icon class="otp-done" *ngIf="mobileOtpRequestId > 0">done</mat-icon>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="otp-row" *ngIf="!isEmailVerified && emailOtpRequestId > 0 && otpTypeEmailMobile.value === 'email'">
          <mat-form-field class="login-field" appearance="outline">
            <mat-label>Email code</mat-label>
            <input matInput [formControl]="VerificationEmailOtp" placeholder="Enter code" maxlength="8" required />
          </mat-form-field>
          <button type="button" class="login-secondary" (click)="onVerifyOtpRequest('email')">Verify</button>
        </div>

        <div class="otp-row" *ngIf="!isMobileVerified && mobileOtpRequestId > 0 && otpTypeEmailMobile.value === 'mobile'">
          <mat-form-field class="login-field" appearance="outline">
            <mat-label>Mobile code</mat-label>
            <input matInput [formControl]="VerificationOtpMobile" placeholder="Enter code" maxlength="8" required />
          </mat-form-field>
          <button type="button" class="login-secondary" (click)="onVerifyOtpRequest('mobile')">Verify</button>
        </div>

        <div *ngIf="isEmailVerified || isMobileVerified">
          <mat-form-field class="login-field" appearance="outline">
            <mat-label>New password</mat-label>
            <input matInput [formControl]="NewPassword" placeholder="New password" [type]="hidePw ? 'password' : 'text'" (keyup)="removeSpaces()" required />
            <button type="button" mat-icon-button matSuffix (click)="hidePw = !hidePw">
              <mat-icon>{{ hidePw ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="NewPassword.touched && NewPassword.hasError('required')">New password is required.</mat-error>
            <mat-error *ngIf="NewPassword.touched && NewPassword.hasError('pattern')">Password must be complex and at least 8 characters.</mat-error>
          </mat-form-field>
          <div class="password-hint">
            8–30 characters, with uppercase, lowercase, a number, and a special character.
          </div>
        </div>

        <button type="button" class="login-submit" (click)="generateOtpUserRequest()" *ngIf="!isEmailVerified && !isMobileVerified"
          [disabled]="(otpTypeEmailMobile.value !== 'mobile' && otpTypeEmailMobile.value !== 'email') || (otp_timer < 30 && otp_timer > 0)">
          {{ emailOtpRequestId > 0 || mobileOtpRequestId > 0 ? 'Resend code' : 'Send code' }}
        </button>

        <button type="button" class="login-submit" (click)="onFinalResetPassword()"
          [disabled]="!NewPassword.valid"
          *ngIf="isEmailVerified || isMobileVerified">
          Save new password
        </button>

        <p class="otpTimer" *ngIf="otp_timer < 30 && otp_timer > 0">Resend available in {{ otp_timer }}s</p>

        <p class="login-card__footer">
          <a class="login-link" role="button" tabindex="0" (click)="LogonBackToLoginin()" (keyup.enter)="LogonBackToLoginin()">Back to sign in</a>
        </p>
      </div>
    </form>

    <aside class="login-host">
      <h3 class="login-host__title">Want to sell on LootLucky?</h3>
      <p class="login-host__copy">List items and run live webinars as a host.</p>
      <a class="login-host__cta" role="button" tabindex="0" (click)="onBecomeHost()" (keyup.enter)="onBecomeHost()">Become a host</a>
      <p class="login-host__disclaimer">Host approval is required before you can start uploading listings.</p>
    </aside>
    </div>
  </section>
</div>
